/**
 * 定数定義.
 * (C)2024 Chubu Electric Power Grid Co.,Inc. All Rights Reserved.
 * version 1.00 NEC 2024/12/31 初版
 */

/** 一束化相手不明会社コード. */
export const ISSOKUKA_AITE_FUMEI_COMPANY_CD = 'FMICOMPANY';

/** 一束化相手不明事業者コード. */
export const ISSOKUKA_AITE_FUMEI_KYOGA_ZIGYOSYA_CD = 'FMIZIG';

// 画面遷移用
export const GMN_PATH = {
  BFA10000G: '/BFA10000G',
  BFA10101G: '/BFA10101G',
  BFA10118G1: '/BFA10118G1',
  BFA10118G2: '/BFA10118G2',
  BFA10128G: '/BFA10128G',
  BFA10130G: '/BFA10130G',
  BFA10401G: '/BFA10401G',
  BFA10403G: '/BFA10403G',
  BFA10405G1: '/BFA10405G1',
  BFA10405G2: '/BFA10405G2',
  BFA10406G: '/BFA10406G',
  BFA10408G: '/BFA10408G',
  BFA10503G: '/BFA10503G',
  BFA10505G: '/BFA10505G',
  BFA10507G: '/BFA10507G',
  BFA10509G: '/BFA10509G',
  BFA10515G: '/BFA10515G',
  BFA10517G: '/BFA10517G',
  BFA10525G: '/BFA10525G',
  BFA10527G: '/BFA10527G',
  BFA10601G: '/BFA10601G',
  BFA10801G: '/BFA10801G',
  BFA10804G: '/BFA10804G',
  BFA10807G: '/BFA10807G',
  BFA10810G: '/BFA10810G',
  BFA10812G: '/BFA10812G',
  BFA10814G: '/BFA10814G',
  BFA10901G: '/BFA10901G',
  BFA10904G: '/BFA10904G',
  BFA90101G: '/BFA90101G',
  BFA90106G: '/BFA90106G',
  BFA90109G: '/BFA90109G',
  BFA90201G: '/BFA90201G',
  BFA90202G: '/BFA90202G',
  BFA90203G: '/BFA90203G',
  BFA10122G: '/BFA10122G',
  BFA10102G: '/BFA10102G',
  BFA10103G: '/BFA10103G',
  BFA10104G: '/BFA10104G',
  BFA10105G: '/BFA10105G',
  BFA10106G: '/BFA10106G',
  BFA10107G: '/BFA10107G',
  BFA10108G: '/BFA10108G',
  BFA10109G: '/BFA10109G',
  BFA10110G: '/BFA10110G',
  BFA10111G: '/BFA10111G',
  BFA10112G: '/BFA10112G',
  BFA10113G: '/BFA10113G',
  BFA10114G: '/BFA10114G',
  BFA10115G: '/BFA10115G',
  BFA10116G: '/BFA10116G',
  BFA10117G: '/BFA10117G',
  BFA10119G: '/BFA10119G',
  BFA10120G: '/BFA10120G',
  BFA10121G: '/BFA10121G',
  BFA10123G: '/BFA10123G',
  BFA10124G: '/BFA10124G',
  BFA10125G: '/BFA10125G',
  BFA10126G: '/BFA10126G',
  BFA10127G: '/BFA10127G',
  BFA10129G: '/BFA10129G',
  BFA10131G: '/BFA10131G',
  BFA10811G: '/BFA10811G',
  BFA10813G: '/BFA10813G',
  BFA10815G: '/BFA10815G',
  BFA10301G: '/BFA10301G',
  BFA10402G: '/BFA10402G',
  BFA10404G: '/BFA10404G',
  BFA10407G: '/BFA10407G',
  BFA10409G: '/BFA10409G',
  BFA10528G: '/BFA10528G',
  BFA10602G: '/BFA10602G',
  BFA10603G: '/BFA10603G',
  BFA10802G: '/BFA10802G',
  BFA10803G: '/BFA10803G',
  BFA10805G: '/BFA10805G',
  BFA10806G: '/BFA10806G',
  BFA10808G: '/BFA10808G',
  BFA10809G: '/BFA10809G',
  BFA10501G: '/BFA10501G',
  BFA10502G: '/BFA10502G',
  BFA10504G: '/BFA10504G',
  BFA10506G: '/BFA10506G',
  BFA10510G: '/BFA10510G',
  BFA10516G: '/BFA10516G',
  BFA10518G: '/BFA10518G',
  BFA10526G: '/BFA10526G',
  BFA10902G: '/BFA10902G',
  BFA10903G: '/BFA10903G',
  BFA10905G: '/BFA10905G',
  BFA10906G: '/BFA10906G',
  BFA90102G: '/BFA90102G',
  BFA90103G: '/BFA90103G',
  BFA90104G: '/BFA90104G',
  BFA90105G: '/BFA90105G',
  BFA90107G: '/BFA90107G',
  BFA90108G: '/BFA90108G',
  BFA90110G: '/BFA90110G',
  BFA90111G: '/BFA90111G',
  BFA90112G: '/BFA90112G',
  BFC401G39: '/BFC401G39',
  BFD10101G: '/BFD10101G',
  BFD10102G: '/BFD10102G',
  BFD10201G: '/BFD10201G',
  BFD20101G: '/BFD20101G',
  BFD20102G: '/BFD20102G',
  BFD20103G: '/BFD20103G',
  BFD20104G: '/BFD20104G',
  BFD20105G: '/BFD20105G',
  BFD20201G: '/BFD20201G',
  BFD20202G: '/BFD20202G',
  BFD40101G: '/BFD40101G',
  BFD40102G: '/BFD40102G',
  BFE10101G: '/BFE10101G',
  BFE10102G: '/BFE10102G',
  BFE10103G: '/BFE10103G',
  BFE10104G: '/BFE10104G',
  BFE10105G: '/BFE10105G',
  BFE10106G: '/BFE10106G',
  BFE10107G: '/BFE10107G',
  BFE10108G: '/BFE10108G',
  BFE10109G: '/BFE10109G',
  BFE10110G: '/BFE10110G',
  BFE10111G: '/BFE10111G',
  BFE10112G: '/BFE10112G',
  BFE20101G: '/BFE20101G',
  BFE30101G: '/BFE30101G',
  BFE30103G: '/BFE30103G',
  BFE40101G: '/BFE40101G',
  BFE30102G: '/BFE30102G',
  BFI10101G: '/BFI10101G',
  BFI10201G: '/BFI10201G',
  BFI20101G: '/BFI20101G',
  BFI20201G: '/BFI20201G',
  BFM10101G: '/BFM10101G',
  BFM10201G: '/BFM10201G',
  BFM10301G: '/BFM10301G',
  BFM10501G: '/BFM10501G',
  BFM10501GBulk: '/BFM10501GBulk',
  BFM10501GBulkTasya: '/BFM10501GBulkTasya',
  BFM10601G: '/BFM10601G',
  BFM10601GBulk: '/BFM10601GBulk',
  BFM10701G: '/BFM10701G',
  BFM10501G01: '/BFM10501G01',
  BFM10502G: '/BFM10502G',
  BFM101G02: '/BFM101G02',
  BFM10202G: '/BFM10202G',
  BFM10302G: '/BFM10302G',
  BFM11001G: '/BFM11001G',
  BFU10101G: '/BFU10101G',
  BFU70101G: '/BFU70101G',
  BFU70103G: '/BFU70103G',
  BFU20101G: '/BFU20101G',
  BFU20104G: '/BFU20104G',
  BFU20105G: '/BFU20105G',
  BFU20201G: '/BFU20201G',
  BFB10101G: '/BFB10101G',
  BFB10106G: '/BFB10106G',
  BFB20101G: '/BFB20101G',
  BFB20105G: '/BFB20105G',
  BFB30101G: '/BFB30101G',
  BFB30201G: '/BFB30201G',
  BFB10102G: '/BFB10102G',
  BFB10103G: '/BFB10103G',
  BFB10104G: '/BFB10104G',
  BFB10105G: '/BFB10105G',
  BFB10107G: '/BFB10107G',
  BFB10108G: '/BFB10108G',
  BFB10109G: '/BFB10109G',
  BFB10115G: '/BFB10115G',
  BFB20102G: '/BFB20102G',
  BFB20103G: '/BFB20103G',
  BFB20104G: '/BFB20104G',
  BFB20106G: '/BFB20106G',
  BFB20107G: '/BFB20107G',
  BFB30102G: '/BFB30102G',
  BFB30103G: '/BFB30103G',
  BFB30202G: '/BFB30202G',
  BFB30203G: '/BFB30203G',
  BFY20101G: '/BFY20101G',
  BFY20102G: '/BFY20102G',
  BFY20103G: '/BFY20103G',
  BFY20104G: '/BFY20104G',
  BFU10102G: '/BFU10102G',
  BFU10103G: '/BFU10103G',
  BFU20102G: '/BFU20102G',
  BFU20103G: '/BFU20103G',
  BFU20106G: '/BFU20106G',
  BFY30101G: '/BFY30101G',
  BFY50101G: '/BFY50101G',
  BFY50102G: '/BFY50102G',
  BFY50103G: '/BFY50103G',
  BFM10102G: '/BFM10102G',
  BFM10901G: '/BFM10901G',
  BFU10101A: '/BFU10101A',
  BFU40101G: '/BFU40101G',
  BFU50101G: '/BFU50101G',
  BFU60102G: '/BFU60102G',
  BFU70104G: '/BFU70104G',
  BFM11002G: '/BFM11002G',
  BFM10401G: '/BFM10401G',
  BFM10402G: '/BFM10402G',
  BFD10301G: '/BFD10301G',
  BFI10102G: '/BFI10102G',
  BFI10202G: '/BFI10202G',
  BFI20202G: '/BFI20202G',
  BFI20102G: '/BFI20102G',
  BFD30101G: '/BFD30101G',
  BFM10602G: '/BFM10602G',
  BFM10702G: '/BFM10702G',
  BFU70102G: '/BFU70102G',
  BFZ10101G: '/BFZ10101G',
  BFZ20101G: '/BFZ20101G',
  BFZ50101G: '/BFZ50101G',
};

export const GMN = {
  BFA10000G: {id: 'BFA10000G', title: '申込詳細情報', name: '共架申込'},
  BFA10101G: {id: 'BFA10101G', title: '申込一覧', name: '共架申込'},
  BFA10102G: {id: 'BFA10102G', title: '共架申込（基本情報）', name: '共架申込（基本情報）'},
  BFA10103G: {id: 'BFA10103G', title: '共架申込（機器設備）', name: '共架申込（機器設備）'},
  BFA10104G: {id: 'BFA10104G', title: '共架申込（通信設備）', name: '共架申込（通信設備）'},
  BFA10105G: {id: 'BFA10105G', title: '共架申込（径間）', name: '共架申込（径間）'},
  BFA10106G: {id: 'BFA10106G', title: '共架申込（分岐点・未登録電柱登録）', name: '共架申込（分岐点・未登録電柱登録）'},
  BFA10107G: {id: 'BFA10107G', title: '既設設備情報入力(設備)', name: '既設設備情報入力(設備)'},
  BFA10108G: {id: 'BFA10108G', title: '既設設備情報入力(径間)', name: '既設設備情報入力(径間)'},
  BFA10109G: {id: 'BFA10109G', title: '共架申込内容確認', name: '共架申込内容確認'},
  BFA10110G: {id: 'BFA10110G', title: '共架申込受付一覧', name: '共架申込受付一覧'},
  BFA10111G: {id: 'BFA10111G', title: '共架申込受付（基本情報）', name: '共架申込受付（基本情報）'},
  BFA10112G: {id: 'BFA10112G', title: '共架申込差戻し', name: '共架申込差戻し'},
  BFA10113G: {id: 'BFA10113G', title: '共架申込受付（設備情報）', name: '共架申込受付（設備情報）'},
  BFA10114G: {id: 'BFA10114G', title: '共架申込物件情報（径間）', name: '共架申込物件情報（径間）'},
  BFA10115G: {id: 'BFA10115G', title: '一束化明細確認（参照）', name: '一束化明細確認（参照）'},
  BFA10116G: {id: 'BFA10116G', title: '既設設備情報修正確認（設備）', name: '既設設備情報修正確認（設備）'},
  BFA10117G: {id: 'BFA10117G', title: '既設設備情報修正確認（径間）', name: '既設設備情報修正確認（径間）'},
  BFA10118G: {id: 'BFA10118G', title: '共架申込一覧（技術検討依頼(机上)）', name: '共架申込一覧（技術検討依頼(机上)）'},
  BFA10118G1: {id: 'BFA10118G1', key: 'BFA10118G1', title: '共架申込一覧（技術検討依頼(机上)）', name: '共架申込一覧（技術検討依頼(机上)）'},
  BFA10118G2: {id: 'BFA10118G2', key: 'BFA10118G2', title: '共架申込一覧（技術検討承認(机上)）', name: '共架申込一覧（技術検討承認(机上)）'},
  BFA10119G: {id: 'BFA10119G', title: '技術検討担当割当／結果承認', name: '技術検討担当割当／結果承認'},
  BFA10120G: {id: 'BFA10120G', title: '共架申込（設備情報）（参照）', name: '共架申込（設備情報）（参照）'},
  BFA10121G: {id: 'BFA10121G', title: '共架申込（径間）（参照）', name: '共架申込（径間）（参照）'},
  BFA10122G: {id: 'BFA10122G'},
  BFA10123G: {id: 'BFA10123G', title: '共架申込取消登録（基本情報）', name: '共架申込取消登録（基本情報）'},
  BFA10124G: {id: 'BFA10124G', title: '共架申込取消登録（設備）', name: '共架申込取消登録（設備）'},
  BFA10125G: {id: 'BFA10125G', title: '共架申込取消登録（径間）', name: '共架申込取消登録（径間）'},
  BFA10126G: {id: 'BFA10126G', title: '既設設備情報入力(分岐点・未登録電柱)', name: '既設設備情報入力(分岐点・未登録電柱)'},
  BFA10127G: {id: 'BFA10127G', title: '既設設備情報修正確認（分岐点・未登録電柱）', name: '既設設備情報修正確認（分岐点・未登録電柱）'},
  BFA10128G: {id: 'BFA10128G', title: '共架本申込登録一覧', name: '共架本申込登録一覧'},
  BFA10129G: {id: 'BFA10129G', title: '共架本申込登録', name: '共架本申込登録'},
  BFA10130G: {id: 'BFA10130G', title: '共架承認一覧', name: '共架承認一覧'},
  BFA10131G: {id: 'BFA10131G', title: '共架承認（基本情報）', name: '共架承認（基本情報）'},
  BFA10301G: {id: 'BFA10301G', title: '共架申込（一束化明細入力）', name: '共架申込（一束化明細入力）'},
  BFA10401G: {id: 'BFA10401G', title: '関連申込一覧', name: '関連申込一覧'},
  BFA10402G: {id: 'BFA10402G', title: '関連申込詳細（参照）', name: '関連申込詳細（参照）'},
  BFA10403G: {id: 'BFA10403G', title: '技術検討依頼一覧（机上）', name: '技術検討依頼一覧（机上）'},
  BFA10404G: {id: 'BFA10404G', title: '技術検討内容登録（机上）', name: '技術検討内容登録（机上）'},
  BFA10405G: {id: 'BFA10405G', title: '共架申込一覧（技術検討依頼(現場)）', name: '共架申込一覧（技術検討依頼(現場)）'},
  BFA10405G1: {id: 'BFA10405G1', title: '共架申込一覧（技術検討依頼(現場)）', name: '共架申込一覧（技術検討依頼(現場)）'},
  BFA10405G2: {id: 'BFA10405G2', title: '共架申込一覧（技術検討承認(現場)）', name: '共架申込一覧（技術検討承認(現場)）'},
  BFA10406G: {id: 'BFA10406G', title: '技術検討依頼一覧（現場）', name: '技術検討依頼一覧（現場）'},
  BFA10407G: {id: 'BFA10407G', title: '技術検討内容登録（現場）', name: '技術検討内容登録（現場）'},
  BFA10408G: {id: 'BFA10408G'},
  BFA10409G: {id: 'BFA10409G', title: '技術検討結果確認', name: '技術検討結果確認'},
  BFA10501G: {id: 'BFA10501G', title: '改修設計内容登録一覧（通信）', name: '改修設計内容登録一覧（通信）'},
  BFA10502G: {id: 'BFA10502G', title: '改修内容登録（通信）', name: '改修内容登録（通信）'},
  BFA10503G: {id: 'BFA10503G', title: '改修内容承認一覧（通信）', name: '改修内容承認一覧（通信）'},
  BFA10504G: {id: 'BFA10504G', title: '改修内容承認（通信）', name: '改修内容承認（通信）'},
  BFA10505G: {id: 'BFA10505G', title: '改修設計内容登録一覧（配電）', name: '改修設計内容登録一覧（配電）'},
  BFA10506G: {id: 'BFA10506G', title: '改修設計内容登録（配電）', name: '改修設計内容登録（配電）'},
  BFA10507G: {id: 'BFA10507G'},
  BFA10509G: {id: 'BFA10509G', title: '改修設計完了登録一覧', name: '改修設計完了登録一覧'},
  BFA10510G: {id: 'BFA10510G', title: '改修設計完了登録', name: '改修設計完了登録'},
  BFA10515G: {id: 'BFA10515G', title: '改修伝票工程情報登録（配電）一覧', name: '改修伝票工程情報登録（配電）一覧'},
  BFA10516G: {id: 'BFA10516G', title: '改修伝票工程情報登録（配電）', name: '改修伝票工程情報登録（配電）'},
  BFA10517G: {id: 'BFA10517G', title: '改修伝票工程情報登録（通信）一覧', name: '改修伝票工程情報登録（通信）一覧'},
  BFA10518G: {id: 'BFA10518G', title: '改修伝票工程情報登録（通信）', name: '改修伝票工程情報登録（通信）'},
  BFA10525G: {id: 'BFA10525G', title: '改修工事費用精算登録一覧', name: '改修工事費用精算登録一覧'},
  BFA10526G: {id: 'BFA10526G', title: '改修工事費用精算登録', name: '改修工事費用精算登録'},
  BFA10527G: {id: 'BFA10527G', title: '改修工事照会一覧', name: '改修工事照会一覧'},
  BFA10528G: {id: 'BFA10528G', title: '改修工事照会', name: '改修工事照会'},
  BFA10601G: {id: 'BFA10601G', title: '共架しゅん工登録一覧', name: '共架しゅん工登録一覧'},
  BFA10602G: {id: 'BFA10602G', title: '共架しゅん工登録', name: '共架しゅん工登録'},
  BFA10603G: {id: 'BFA10603G', title: '共架しゅん工登録（径間）', name: '共架しゅん工登録（径間）'},
  BFA10801G: {id: 'BFA10801G', title: '施設確認依頼一覧', name: '施設確認依頼一覧'},
  BFA10802G: {id: 'BFA10802G', title: '施設確認担当割当', name: '施設確認担当割当'},
  BFA10803G: {id: 'BFA10803G', title: '施設確認依頼（径間）', name: '施設確認依頼（径間）'},
  BFA10804G: {id: 'BFA10804G', title: '施設確認内容登録一覧', name: '施設確認内容登録一覧'},
  BFA10805G: {id: 'BFA10805G', title: '施設確認内容登録', name: '施設確認内容登録'},
  BFA10806G: {id: 'BFA10806G', title: '施設確認内容登録（径間）', name: '施設確認内容登録（径間）'},
  BFA10807G: {id: 'BFA10807G', title: '施設確認結果承認一覧', name: '施設確認結果承認一覧'},
  BFA10808G: {id: 'BFA10808G', title: '施設確認結果承認', name: '施設確認結果承認'},
  BFA10809G: {id: 'BFA10809G', title: '施設確認結果承認（径間）', name: '施設確認結果承認（径間）'},
  BFA10810G: {id: 'BFA10810G'},
  BFA10811G: {id: 'BFA10811G', title: '施設確認結果確認・改修工事依頼／申込', name: '施設確認結果確認・改修工事依頼／申込'},
  BFA10812G: {id: 'BFA10812G', title: '改修可否判定依頼一覧', name: '改修可否判定依頼一覧'},
  BFA10813G: {id: 'BFA10813G', title: '改修可否判定担当割当', name: '改修可否判定担当割当'},
  BFA10814G: {id: 'BFA10814G', title: '改修可否判定一覧', name: '改修可否判定一覧'},
  BFA10815G: {id: 'BFA10815G', title: '改修可否判定登録', name: '改修可否判定登録'},
  BFA10901G: {id: 'BFA10901G', title: '共架設備改修通知書（巡視発見）発行一覧', name: '共架設備改修通知書（巡視発見）発行一覧'},
  BFA10902G: {id: 'BFA10902G', title: '共架設備改修通知書発行（基本情報）', name: '共架設備改修通知書発行（基本情報）'},
  BFA10903G: {id: 'BFA10903G', title: '共架設備改修通知書発行（詳細）', name: '共架設備改修通知書発行（詳細）'},
  BFA10904G: {id: 'BFA10904G', title: '共架設備改修通知書確認一覧', name: '共架設備改修通知書確認一覧'},
  BFA10905G: {id: 'BFA10905G', title: '共架設備改修通知書確認', name: '共架設備改修通知書確認'},
  BFA10906G: {id: 'BFA10906G', title: '共架設備改修通知書確認・改修工事依頼／申込', name: '共架設備改修通知書確認・改修工事依頼／申込'},
  BFA90101G: {id: 'BFA90101G', title: '共架申込（他社柱）一覧', name: '共架申込（他社柱）一覧'},
  BFA90102G: {id: 'BFA90102G', title: '共架申込（他社柱）（基本情報）', name: '共架申込（他社柱）（基本情報）'},
  BFA90103G: {id: 'BFA90103G', title: '共架申込（他社柱）（設備）', name: '共架申込（他社柱）（設備）'},
  BFA90104G: {id: 'BFA90104G', title: '共架申込（他社柱）（径間）', name: '共架申込（他社柱）（径間）'},
  BFA90105G: {id: 'BFA90105G', title: '共架申込確認（他社柱）', name: '共架申込確認（他社柱）'},
  BFA90106G: {id: 'BFA90106G', title: '共架申込（他社柱）（承認済み）一覧', name: '共架申込（他社柱）（承認済み）一覧'},
  BFA90107G: {id: 'BFA90107G', title: '共架申込（他社柱）（設備）（承認済み）', name: '共架申込（他社柱）（設備）（承認済み）'},
  BFA90108G: {id: 'BFA90108G', title: '共架申込（他社柱）（径間）（承認済み）', name: '共架申込（他社柱）（径間）（承認済み）'},
  BFA90109G: {id: 'BFA90109G', title: '共架申込一覧（他社柱）（取消）', name: '共架申込一覧（他社柱）（取消）'},
  BFA90110G: {id: 'BFA90110G', title: '共架申込内容（他社柱）（基本）', name: '共架申込内容（他社柱）（基本）'},
  BFA90111G: {id: 'BFA90111G', title: '共架申込内容（他社柱）（設備）', name: '共架申込内容（他社柱）（設備）'},
  BFA90112G: {id: 'BFA90112G', title: '共架申込内容（他社柱）（径間）', name: '共架申込内容（他社柱）（径間）'},
  BFA90201G: {id: 'BFA90201G', title: '共架申込受付一覧', name: '共架申込受付一覧'},
  BFA90202G: {id: 'BFA90202G', title: '共架申込受付（基本・設備）', name: '共架申込受付（基本・設備）'},
  BFA90203G: {id: 'BFA90203G', title: '共架申込受付（径間）', name: '共架申込受付（径間）'},
  BFB10101G: {id: 'BFB10101G', title: '共架柱変更連絡一覧', name: '共架柱変更連絡一覧'},
  BFB10102G: {id: 'BFB10102G', title: '共架柱変更連絡票発行', name: '共架柱変更連絡票発行'},
  BFB10103G: {id: 'BFB10103G', title: '共架柱変更連絡票詳細（対象電柱）', name: '共架柱変更連絡票詳細（対象電柱）'},
  BFB10104G: {id: 'BFB10104G', title: '共架柱変更連絡票詳細（共架者）', name: '共架柱変更連絡票詳細（共架者）'},
  BFB10105G: {id: 'BFB10105G', title: '共架柱変更連絡票詳細（共架者別対象電柱選択）', name: '共架柱変更連絡票詳細（共架者別対象電柱選択）'},
  BFB10106G: {id: 'BFB10106G', title: '共架柱変更連絡票確認一覧', name: '共架柱変更連絡票確認一覧'},
  BFB10107G: {id: 'BFB10107G', title: '共架柱変更連絡票確認', name: '共架柱変更連絡票確認'},
  BFB10108G: {id: 'BFB10108G', title: '工事予定表示（チャート）', name: '工事予定表示（チャート）'},
  BFB10109G: {id: 'BFB10109G', title: '共架柱変更連絡票詳細（対象電柱）', name: '共架柱変更連絡票詳細（対象電柱）'},
  BFB10115G: {id: 'BFB10115G', title: '共架柱変更連絡履歴', name: '共架柱変更連絡履歴'},
  BFB20101G: {id: 'BFB20101G', title: '移設結果登録一覧', name: '移設結果登録一覧'},
  BFB20102G: {id: 'BFB20102G', title: '移設結果登録（基本情報）', name: '移設結果登録（基本情報）'},
  BFB20103G: {id: 'BFB20103G', title: '移設結果登録（設備）', name: '移設結果登録（設備）'},
  BFB20104G: {id: 'BFB20104G', title: '移設結果登録（径間）', name: '移設結果登録（径間）'},
  BFB20105G: {id: 'BFB20105G', title: '仮移設登録一覧', name: '仮移設登録一覧'},
  BFB20106G: {id: 'BFB20106G', title: '仮移設登録（共架者一覧）', name: '仮移設登録（共架者一覧）'},
  BFB20107G: {id: 'BFB20107G', title: '仮移設登録（共架者別対象電柱一覧）', name: '仮移設登録（共架者別対象電柱一覧）'},
  BFB30101G: {id: 'BFB30101G', title: '共架柱変更連絡票一覧（NTT）', name: '共架柱変更連絡票一覧（NTT）'},
  BFB30102G: {id: 'BFB30102G', title: '共架柱変更連絡票確認（NTT）', name: '共架柱変更連絡票確認（NTT）'},
  BFB30103G: {id: 'BFB30103G', title: '共架柱変更連絡票詳細（対象電柱）（NTT）', name: '共架柱変更連絡票詳細（対象電柱）（NTT）'},
  BFB30201G: {id: 'BFB30201G', title: '共架柱変更連絡票一覧（NTT）', name: '共架柱変更連絡票一覧（NTT）'},
  BFB30202G: {id: 'BFB30202G', title: '共架柱変更連絡票発行（NTT）', name: '共架柱変更連絡票発行（NTT）'},
  BFB30203G: {id: 'BFB30203G', title: '共架柱変更連絡票詳細（対象電柱）（NTT）', name: '共架柱変更連絡票詳細（対象電柱）（NTT）'},
  BFC401G39: {id: 'BFC401G39', title: '', name: ''},
  BFD10101G: {id: 'BFD10101G', title: '共架柱・共架物件一覧検索', name: '共架柱・共架物件一覧検索'},
  BFD10102G: {id: 'BFD10102G'},
  BFD10201G: {id: 'BFD10201G'},
  BFD10301G: {id: 'BFD10301G', title: '支持物確認リスト・確認結果登録', name: '支持物確認リスト・確認結果登録'},
  BFD20101G: {id: 'BFD20101G'},
  BFD20102G: {id: 'BFD20102G', title: '共架柱登録', name: '共架柱登録'},
  BFD20103G: {id: 'BFD20103G', title: '共架柱登録（径間）', name: '共架柱登録（径間）'},
  BFD20104G: {id: 'BFD20104G', title: '共架柱登録（分岐点・未登録電柱）', name: '共架柱登録（分岐点・未登録電柱）'},
  BFD20105G: {id: 'BFD20105G', title: '共架柱登録（一束化）', name: '共架柱登録（一束化）'},
  BFD20201G: {id: 'BFD20201G'},
  BFD20202G: {id: 'BFD20202G', title: '共架柱登録内容確認', name: '共架柱登録内容確認'},
  BFD30101G: {id: 'BFD30101G', title: '減免申請対象リスト・確認結果登録', name: '減免申請対象リスト・確認結果登録'},
  BFD40101G: {id: 'BFD40101G', title: '所有権移転登録一覧', name: '所有権移転登録一覧'},
  BFD40102G: {id: 'BFD40102G', title: '所有権移転登録', name: '所有権移転登録'},
  BFE10101G: {id: 'BFE10101G', title: '請求一覧', name: '請求一覧'},
  BFE10102G: {id: 'BFE10102G', title: '共架料金明細', name: '共架料金明細'},
  BFE10103G: {id: 'BFE10103G', title: '共架物件明細', name: '共架物件明細'},
  BFE10104G: {id: 'BFE10104G', title: '請求明細（技術検討費用）', name: '請求明細（技術検討費用）'},
  BFE10105G: {id: 'BFE10105G', title: '請求明細（改修工事費用）', name: '請求明細（改修工事費用）'},
  BFE10106G: {id: 'BFE10106G', title: '請求明細（共架申込代行費用）', name: '請求明細（共架申込代行費用）'},
  BFE10107G: {id: 'BFE10107G', title: '請求明細（しゅん工報告代行費用）', name: '請求明細（しゅん工報告代行費用）'},
  BFE10108G: {id: 'BFE10108G', title: '請求明細（しゅん工調査費用）', name: '請求明細（しゅん工調査費用）'},
  BFE10109G: {id: 'BFE10109G', title: '請求明細（仮移設費用）', name: '請求明細（仮移設費用）'},
  BFE10110G: {id: 'BFE10110G', title: '請求明細（延滞利息）', name: '請求明細（延滞利息）'},
  BFE10111G: {id: 'BFE10111G', title: '共架料明細表', name: '共架料明細表'},
  BFE10112G: {id: 'BFE10112G', title: '請求明細（再請求）', name: '請求明細（再請求）'},
  BFE10201G: {id: 'BFE10201G', title: '請求明細（技術検討費用）', name: '請求明細（技術検討費用）'},
  BFE20101G: {id: 'BFE20101G', title: '個別費用請求・払戻', name: '個別費用請求・払戻'},
  BFE30101G: {id: 'BFE30101G', title: '定期共架料修正申請', name: '定期共架料修正申請'},
  BFE30102G: {id: 'BFE30102G'},
  BFE30103G: {id: 'BFE30103G', title: '修正申請内容確認登録', name: '修正申請内容確認登録'},
  BFE40101G: {id: 'BFE40101G', title: '入金消込', name: '入金消込'},
  BFI10101G: {id: 'BFI10101G', title: 'メッセージ一覧', name: 'メッセージ一覧'},
  BFI10102G: {id: 'BFI10102G', title: 'メッセージ送信／確認', name: 'メッセージ送信／確認'},
  BFI10201G: {id: 'BFI10201G', title: 'メッセージ一覧', name: 'メッセージ一覧'},
  BFI10202G: {id: 'BFI10202G', title: 'メッセージ送信／確認', name: 'メッセージ送信／確認'},
  BFI20101G: {id: 'BFI20101G', title: '重要事項通知登録一覧', name: '重要事項通知登録一覧'},
  BFI20102G: {id: 'BFI20102G', title: '重要事項通知登録', name: '重要事項通知登録'},
  BFI20201G: {id: 'BFI20201G', title: '重要事項通知確認一覧', name: '重要事項通知確認一覧'},
  BFI20202G: {id: 'BFI20202G', title: '重要事項通知確認', name: '重要事項通知確認'},
  BFM10101G: {id: 'BFM10101G', title: '汎用マスタ一覧', name: '汎用マスタ一覧'},
  BFM10102G: {id: 'BFM10102G', title: '汎用マスタ（詳細）', name: '汎用マスタ（詳細）'},
  BFM10201G: {id: 'BFM10201G', title: '単価マスタ一覧', name: '単価マスタ一覧'},
  BFM10202G: {id: 'BFM10202G', title: '単価マスタ（詳細）', name: '単価マスタ（詳細）'},
  BFM10301G: {id: 'BFM10301G', title: '消費税マスタ（一覧）', name: '消費税マスタ（一覧）'},
  BFM10302G: {id: 'BFM10302G', title: '消費税マスタ（詳細）', name: '消費税マスタ（詳細）'},
  BFM10401G: {id: 'BFM10401G', title: 'カレンダ設定（システム稼働日）', name: 'カレンダ設定（システム稼働日）'},
  BFM10402G: {id: 'BFM10402G', title: 'カレンダ設定（中電営業日）', name: 'カレンダ設定（中電営業日）'},
  BFM10501G: {id: 'BFM10501G', title: '電柱マスタ（一覧）', name: '電柱マスタ（一覧）'},
  BFM10501GBulk: {id: 'BFM10501GBulk'},
  BFM10501GBulkTasya: {id: 'BFM10501GBulkTasya'},
  BFM10502G: {id: 'BFM10502G', title: '電柱マスタ（詳細）', name: '電柱マスタ（詳細）'},
  BFM10601G: {id: 'BFM10601G', title: '共架不可電柱情報マスタ（一覧）', name: '共架不可電柱情報マスタ（一覧）'},
  BFM10601GBulk: {id: 'BFM10601GBulk'},
  BFM10602G: {id: 'BFM10602G', title: '共架不可電柱情報マスタ（詳細）', name: '共架不可電柱情報マスタ（詳細）'},
  BFM10701G: {id: 'BFM10701G', title: '共架不可電柱条件マスタ（一覧）', name: '共架不可電柱条件マスタ（一覧）'},
  BFM10702G: {id: 'BFM10702G', title: '共架不可電柱条件マスタ（詳細）', name: '共架不可電柱条件マスタ（詳細）'},
  BFM10901G: {id: 'BFM10901G', title: '事業場マスタ', name: '事業場マスタ'},
  BFM11001G: {id: 'BFM11001G', title: '期限管理マスタ一覧', name: '期限管理マスタ一覧'},
  BFM11002G: {id: 'BFM11002G', title: '期限管理マスタ', name: '期限管理マスタ'},
  BFU10101A: {id: 'BFU10101A', title: '基本契約締結（契約書受領／捺印）', name: '基本契約締結（契約書受領／捺印）'},
  BFU10101G: {id: 'BFU10101G', title: '基本契約締結申込一覧', name: '基本契約締結申込一覧'},
  BFU10102G: {id: 'BFU10102G', title: '基本契約締結（契約書（案））確認', name: '基本契約締結（契約書（案））確認'},
  BFU10103G: {id: 'BFU10103G', title: '基本契約締結決裁', name: '基本契約締結決裁'},
  BFU20101G: {id: 'BFU20101G'},
  BFU20102G: {id: 'BFU20102G', title: '共架者基本情報(編集)', name: '共架者基本情報(編集)'},
  BFU20103G: {id: 'BFU20103G', title: '共架者基本情報(参照)', name: '共架者基本情報(参照)'},
  BFU20104G: {id: 'BFU20104G', title: '共架者情報編集申込一覧', name: '共架者情報編集申込一覧'},
  BFU20105G: {id: 'BFU20105G'},
  BFU20106G: {id: 'BFU20106G', title: '共架者情報編集', name: '共架者情報編集'},
  BFU20201G: {id: 'BFU20201G', title: '契約解除対象共架者一覧', name: '契約解除対象共架者一覧'},
  BFU40101G: {id: 'BFU40101G', title: 'ユーザー情報変更', name: 'ユーザー情報変更'},
  BFU50101G: {id: 'BFU50101G', title: 'ダッシュボード', name: 'ダッシュボード'},
  BFU70101G: {id: 'BFU70101G', title: '約款改定通知一覧', name: '約款改定通知一覧'},
  BFU70102G: {id: 'BFU70102G', title: '約款改定通知登録', name: '約款改定通知登録'},
  BFU70103G: {id: 'BFU70103G', title: '約款改定通知確認一覧', name: '約款改定通知確認一覧'},
  BFU70104G: {id: 'BFU70104G', title: '約款改定通知確認', name: '約款改定通知確認'},
  BFU60101G: {id: 'BFU60101G', title: 'ロール選択', name: 'ロール選択'},
  BFU60102G: {id: 'BFU60102G', title: 'ロール設定', name: 'ロール設定'},
  BFY20101G: {id: 'BFY20101G', title: '承認一覧', name: '承認一覧'},
  BFY20102G: {id: 'BFY20102G', title: '承認一覧', name: '承認一覧'},
  BFY20103G: {id: 'BFY20103G', title: '承認申請一覧', name: '承認申請一覧'},
  BFY20104G: {id: 'BFY20104G', title: '承認申請一覧', name: '承認申請一覧'},
  BFY30101G: {id: 'BFY30101G', title: '事業場・担当者選択', name: '事業場・担当者選択'},
  BFY40101G: {id: 'BFY40101G', title: '電柱選択', name: '電柱選択'},
  BFY50101G: {id: 'BFY50101G', title: '電柱写真登録', name: '電柱写真登録'},
  BFY50102G: {id: 'BFY50102G', title: '添付写真参照', name: '添付写真参照'},
  BFY50103G: {id: 'BFY50103G', title: '資料登録', name: '資料登録'},
  BFY60101G: {id: 'BFY60101G', title: '共架者選択', name: '共架者選択'},
  BFZ10101G: {id: 'BFZ10101G', title: '代行開始／終了', name: '代行開始／終了'},
  BFZ20101G: {id: 'BFZ20101G', title: 'CSV一覧', name: 'CSV一覧'},
  BFZ50101G: {id: 'BFZ50101G', title: 'エラー一覧', name: 'エラー一覧'},
};

// Grid状態
export const GRID_STATUS = {
  INSERT: 'insert',
  UPDATE: 'update',
  DELETE: 'delete',
};

// アップロード可能なファイル
export const UPLOAD_EXTENSION = '';

// 取込可能なファイル
export const IMPORTABLE_EXTENSION = '.xlsx';

// 汎用マスタのカテゴリ
export const CATEGORY_TYPE = {
  NTT_EIGYOSYO: 'ntt_eigyosyo',
  NTT_DNT_CATEGORY: 'ntt_dnt_category',
  TANJYAKU_TYOJYAKU: 'tanjyaku_tyojyaku',
  KASETU_BUNRUI: 'kasetu_bunrui',
  KEIKAN_TYPE: 'keikan_type',
  SENYU_SIZE: 'senyu_size',
  ZIGYOJO: 'zigyojo_cd',
  PREFECTURES: 'prefectures',
  MUNICIPALITIES: 'municipalities',
  OAZATUSYO: 'oazatusyo',
  AZATYOME: 'azatyome',
  ORDERSTATUS: 'order_status',
  ORDERSTATUS_NTT: 'order_status_ntt',
  KYOGATYU_TOROKU_STATUS: 'kyogatyu_toroku_status',
  ISSOKUKA: 'issokuka_category',
  POSITION_LINK: 'position_link',
  IDO_TYPE: 'ido_type',
  KASETU_SETUBI_CD: 'kasetu_setubi_cd',
  KASETU_SETUBI_CD_NTT: 'kasetu_setubi_cd_ntt',
  SUIHEI_TYOKAKU_ZAHYOKEI: 'suihei_tyokaku_zahyokei',
  KASETU_SETUBI_TYPE: 'kasetu_setubi_type',
  SENKA_JYOKYO: 'senka_jyokyo',
  TORITUKE_WAY: 'torituke_way',
  TORITUKE_HOI: 'torituke_hoi',
  TORITUKE_TYPE: 'torituke_type',
  SAISEKKIN_HAIDEN_SETUBI: 'saisekkin_haiden_setubi',
  UMU_CATEGORY: 'umu_category',
  SEKKEI_UMU_JYOKEN_CATEGORY: 'sekkei_umu_jyoken_category',
  SEKKEI_UMU_CATEGORY: 'sekkei_umu_category',
  KISETU_UMU_CATEGORY: 'kisetu_umu_category',
  SOUSA_HIMO_ISETU_YOHI: 'sousa_himo_isetu_yohi',
  KAISYU_KOJI_IRAI_NAIYO: 'kaisyu_koji_irai_naiyo',
  KYOGATYUHENKOSTATUS: 'kyogatyu_henko_status',
  MOSIKOMISYA_YUSYOMUSYO_CATEGORY: 'yusyou_musyo_category',
  HENKOU_RENRAKU_CATEGORY: 'henko_renraku_category',
  KIINSYA: 'kiinsya',
  KAHI_CATEGORY: 'kahi_category',
  YOUHI_CATEGORY: 'youhi_category',
  GIJYUTU_KENTO_KEKKA_CATEGORY: 'gijyutu_kento_kekka',
  GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY: 'gijyutu_kento_kekka_kajyoken',
  GIJYUTU_KENTO_KEKKA_FUKARIYU: 'gijyutu_kento_kekka_fukariyu',
  GIJYUTU_KENTO_KEKKA_GENBARIYU: 'gijyutu_kento_kekka_genba_riyu',
  HIMO_IAETU_JISSI_CATEGORY: 'himo_isetu_jissi_category',
  TUSIN_KAIHU_RIYU: 'tusin_kaifuriyu',
  TOSYA_KAISYU_IRAI_HI_RIYU: 'tosya_kaisyu_irai_hi_riyu',
  YOUHI_CATEGORY_HAIDEN_KAISYU: 'yohi_category_haiden_kaisyu',
  KAISYU_KOJI_NAIYO_HAIDEN: 'kaisyu_koji_naiyo_haiden',
  KAISYU_KOJI_NAIYO_TUSIN: 'kaisyu_koji_naiyo_tusin',
  BUNKITEN_MITOROKU_TYPE: 'bunkiten_mitoroku_type',
  HENKO_RENRAKU_KOJI_TYPE: 'henko_renraku_koji_type',
  DEMPYO_CATEGORY: 'dempyo_category',
  ORDER_KAIJYO_CATEGORY: 'order_kaijyo_category',
  KYOGATYU_HENKO_KOJI_NAIYO: 'kyogatyu_henko_koji_naiyo',
  SIJIBUTU_KIND: 'sijibutu_kind',
  IDO_EW: 'ido_ew',
  IDO_SN: 'ido_sn',
  USER_LEVEL: 'user_level',
  KYOGA_BUKKEN_SYURUI_CD: 'kyoga_bukken_kind_cd',
  CATEGORY_TYPE: 'category_type',
  HENKO_RENRAKU_TAISYO: 'henko_renraku_taisyo',
  HENKO_RENRAKU_TUTI_HOHO: 'henko_renraku_tuti_hoho',
  KYOGATYU_HENKO_STATUS: 'kyogatyu_henko_status',
  TEKI_FUTEKI_CATEGORY: 'teki_futeki_category',
  FUTEKI_CATEGORY: 'futeki_category',
  OWNER: 'owner',
  DNT_CATEGORY: 'dnt_category',
  KYOGASYA_KAISYU_KOJI_NAIYO: 'kyogasya_kaisyu_koji_naiyo',
  COMPANY_CD: 'company_cd',
  ZIGYOJO_CATEGORY: 'zigyojo_category',
  ZIGYOJO_LEVEL: 'zigyojo_level',
  YAKUWARI_ROLE_ID: 'yakuwari_role_id',
  CALLENDER_TYPE: 'callender_type',
  KYOGA_HIYO_CATEGORY: 'kyoga_hiyo_category',
  UNIT_PRICE_CATEGORY: 'unit_price_category',
  UNIT_PRICE_SUB_CATEGORY: 'unit_price_sub_category',
  COMPANY_CATEGORY: 'company_category',
  GENGAKU_CATEGORY: 'gengaku_category',
  SHOUHIZEI: 'sales_tax',
  HENKO_RENRAKU_KOJI_KIND: 'henko_renraku_koji_kind',
  KYOGATYU_HENKO_ISETU_KOJI_NAIYO: 'kyogatyu_henko_isetu_koji_naiyo',
  KASETU_SETUBI_BUNRUI: 'kasetu_setubi_bunrui',
  DOTYOSEKO_KAHI: 'dotyoseko_kahi',
  JYUYODO: 'jyuyodo',
  JYUYOJIKO_RENRAKU_TYPE: 'jyuyojiko_renrakuType',
  YAKKAN_STATUS: 'yakkan_status',
  MESSAGE_RENRAKU_NAIYO: 'message_renraku_naiyo',
  SETUBI_NAME: 'setubi_name',
  KYOGA_CATEGORY: 'kyoga_category',
  SOUSAHIMO_KOTEIHOHO: 'sousa_himo_kotei_hoho',
  KEIYAKU_ORDER_TYPE: 'keiyaku_order_type',
  COMPANY_TYPE: 'company_type',
  COMPANY_TYPE_COMPANY_MST: 'company_type',
  ORDER_MAXIMUM_SETUBI: 'order_maximum_setubi',
  ORDER_MAXIMUM_KEIKAN: 'order_maximum_keikan',
  ORDER_MAXIMUM_BUNKI_MITOROKU: 'order_maximum_bunki_mitoroku',
  KEIKAN_MAXIMUM_LENGTH: 'keikan_maximum_length',
  TIJYO_MAXIMUM_HEIGHT: 'tijyo_maximum_height',
  JYUYOJIKO_RENRAKU_CATEGORY: 'jyuyojiko_renraku_type',
  KAISYU_KOJI_BASE_HAIDEN: 'kaisyu_koji_base_haiden',
  KAISYU_KOJI_BASE_TUSIN: 'kaisyu_koji_base_tusin',
  KAISYU_KOJI_KASAN_HAIDEN: 'kaisyu_koji_kasan_haiden',
  KYOGATYU_HENKO_KYOGASYA_STATUS: 'kyogatyu_henko_kyogasya_status',
  KYOGATYU_HENKO_KYOGASYA_STATUS_TASYA: 'kyogatyu_henko_kyogasya_status_tasya',
  KYOGA_TANTOKASYO: 'kyoga_tantokasyo_cd',
  SASIMODOSI_CATEGORY: 'sasimodosi_category',
  GENERIC_MST: 'generic_mst',
  SEKKEI_CATEGORY: 'sekkei_category',
  KAISYU_TUTI_HOHO_JYUNSI: 'kaisyu_tuti_hoho_jyunsi',
  ORDER_CATEGORY: 'order_category',
  DENTU_TURISEN_COMPANY_CD: 'dentu_turisen_company_cd',
  SEIKYU_TAISYO_KIKAN: 'seikyu_taisyo_kikan',
  SONOTA_SEIKYU_TAISYO_KIKAN: 'sonota_seikyu_taisyo_kikan',
  SIHARAI_HOHO_CATEGORY: 'siharai_hoho_category',
  SEIKYUSYO_CREATE_CATEGORY: 'seikyusyo_create_category',
  KOZA_TYPE: 'koza_type',
  LIMIT: 'limit',
  KESSAI_HOHO: 'kessai_hoho',
  KYOGA_TYPE: 'kyoga_type',
  JIZEN_TUTI_YOHI: 'jizen_tuti_yohi',
  JIZEN_TUTI_KAKUNIN_TUKI: 'jizen_tuti_kakunin_tuki',
  SETTI_KOHO: 'setti_koho',
  TIMOKU: 'timoku',
  KANTYO_CD: 'kantyo_cd',
  DORO_CD: 'doro_cd',
  INTER_COMPANY_TRAN_FLAG: 'inter_company_tran_flag',
  KAN_MIN_CATEGORY: 'kan_min_category',
  ZOGEN_CATEGORY: 'zogen_category',
  SEIKYU_YOHI_HENKO: 'seikyu_yohi_henko',
  MAX_ROW_SIZE: 'max_row_size',
  LINK_URL: 'link_url',
};

// 一束化区分
export const ISSOKUKA_TYPE = {
  TANDOKU: '1', // 単独
  NISYA: '2', // 2者
  SANSYA: '3', // 3者
  YONSYA: '4', // 4者
};

// 申込区分
export const ORDER_CATEGORY = {
  ORDER: '1', // 共架申込
  KAISYU_IRAI_JYUNSI: '2', // 改修依頼(巡視)
  KAISYU_IRAI_HUTEKI: '3', // 改修依頼(不適)
  KYOGATYU_TOROKU: '4', // 共架柱登録
  TASYATYU_ORDER: '5', // 他社柱申込
  TORIKESI_ORDER: '6', // 申込取消
  ISSOKUKA_AITESAKI: '7', // 一束化相手先
  SYOYUKEN_ITEN: '8', // 所有権移転
  TORIKESI_ORDER_TASYATYU: '9', // 申込取消(他社柱)
};

// 契約申込種別
export const ORDER_KIND = {
  IPPAN: 0, // 一般共架
  GAIROTO: 1, // 街路灯
  ZIGYOSYA: 2, // 事業者追加
};

// 共架設備種別
export const KYOGA_SETUBI_TYPE = {
  TUSHIN: '1', // 通信設備
  KIKI: '2', // 機器設備
  GAIRO: '3', // 街路灯
};

// 既設区分
export const KISETU_CATEGORY = {
  ORDER: '1', // 申込
  KISETU_HOSEI: '2', // 既設補正
};

// 径間種別
export const KEIKAN_TYPE = {
  ORDER: '0', // 申込
  KYODO: '1', // 強度計算
};

// 申込ステータス
export const ORDER_STATUS = {
  ORDER_CREATED: '01', // 作成中
  GIJYUTU_KENTO_SHINSEITYU: '02', // 技術検討申請中
  ORDER_RECEIVE: '03', // 技術検討申込承認済/申込済
  ORDER_CANCELING: '04', // 取消申請中
  ORDER_CANCELING_CREATED: '05', // 取消依頼作成中
  ORDER_RECEIVED: '07', // 申込受付済
  GIJYUTU_KENTO_IRAIZUMI: '11', // 技術検討依頼済
  GIJYUTU_KENTO_IRAI_HORYU: '12', // 技術検討依頼保留
  GIJYUTU_KENTO_KIJYO_MISYONIN: '13', // 技術検討中／机上結果未承認
  GIJYUTU_KENTO_IRAIMI_GENBA: '14', // 技術検討中/現場依頼未
  GIJYUTU_KENTO_IRAIZUMI_GENBA: '15', // 技術検討中/現場依頼済
  GIJYUTU_KENTO_GENBA_MISYONIN: '16', // 技術検討中/現場結果未承認
  ORDER_SYUSEI_TOROKESI: '17', // 申込修正／取消要
  GIJYUTU_KENTOZUMI_KAISYU_SEKKEITYU: '21', // 技術検討済/改修設計中
  KAISYU_SEKKEIZUMI_KANRYOBIMI: '22', // 改修設計済完了日未
  KAISYU_SEKKEI_MISYONIN: '23', // 改修設計未承認
  KAISYU_SEKKEI_ZUMI: '24', // 改修設計済
  KYOGA_ORDER_MI: '26', // 共架申込未
  KYOGA_ORDER_SHINSEITYU: '27', // 共架申込申請中
  KYOGA_ORDER_CYU: '28', // 共架申込中
  KOJI_ORDER_SUMI: '31', // 工事依頼済
  KOJI_PLAN_ZUMI: '32', // 工事計画済
  KOJI_COMPLETE: '33', // 工事完了
  KYOGAKOJI_KAISHI_KA: '41', // 共架工事開始可
  SYUNKO_TOROKU_SHINSEITYU: '43', // しゅん工登録申請中
  SYUNKO_TOROKU_SUMI: '44', // しゅん工登録済
  SISETU_KAKUNINCHU: '45', // 施設確認中
  SISETU_KAKUNINKEKKA_MISHONIN: '46', // 施設確認結果未承認
  KANKETSU_TORIKESHI: '53', // 完結(取消)
  TOROKU_ZUMI_ITEN_MI: '54', // 登録済（移転処理未）
  JYUNSI_KAISYU_TUTI_CREATE: '61', // 巡視改修通知作成中
  KAISYU_TUTI_HAKKO_SHINSEITYU: '62', // 改修通知発行申請中
  KAISYU_TUTI_SUMI: '63', // 改修通知済
  KAISYU_HOUHOU_KENTOTYU: '64', // 改修方法検討中
  KYOGIKEKKA_TOROKUZUMI: '65', // 協議結果登録済(当社起因)
  KAISYU_SEKKEI_IRAI_CHU: '67', // 改修設計依頼申請中
  KYOGASYA_KAISYU_KOJI_TYU: '66', // 共架者改修工事中
  KAISYU_KOJI_MOUSIKOMI_MI: '68', // 改修工事申込未
  KAISYU_KOJI_MOUSIKOMI_SINSEI_CHU: '69', // 改修工事申込申請中
  KAISYU_KAHI_HANTEI_IRAIMI: '72', // 改修可否判定依頼未
  KAISYU_KAHI_HANTEI_IRAITYU: '73', // 改修可否判定依頼中
  TOUSYA_KAISYU_SASIMODOSI: '74', // 当社改修否差戻
};

// 申込ステータス 共架者
export const ORDER_STATUS_KYOGASYA = {
  ORDER_CREATED: '01', // 作成中
  GIJYUTU_KENTO_SHINSEITYU: '02', // 技術検討申請中
  ORDER_RECEIVE: '03', // 技術検討申込承認済/申込済
  ORDER_CANCELING: '04', // 取消申請中
  ORDER_CANCELING_CREATED: '05', // 取消依頼作成中
  TORIKESI_ORDER_ZUMI: '06', // 取消申込済
  ORDER_RECEIVED: '07', // 申込受付済
  GIJYUTU_KENTO_IRAIZUMI: '08', // 技術検討依頼済
  GIJYUTU_KENTOTYU: '09', // 技術検討中
  ORDER_SYUSEI_TOROKESI: '11', // 申込修正／取消要
  KAISYU_SEKKEITYU: '21', // 改修設計中
  TASYA_KOJITYU: '25', // 他社工事中
  KYOGA_ORDER_MI: '26', // 共架申込未
  KYOGA_ORDER_SHINSEITYU: '27', // 共架申込申請中
  KYOGA_ORDER_CYU: '28', // 共架申込中
  KOJI_ORDER_SUMI: '31', // 工事依頼済
  KOJI_PLAN_ZUMI: '32', // 工事計画済
  KOJI_COMPLETE: '33', // 工事完了
  KYOGAKOJI_KAISHI_KA: '41', // 共架工事開始可
  SYUNKO_TOROKU_SHINSEITYU: '43', // しゅん工登録申請中
  SYUNKO_TOROKU_SUMI: '44', // しゅん工登録済
  SISETU_KAKUNINCHU: '45', // 施設確認中
  SISETU_KAKUNINKEKKA_MISHONIN: '46', // 施設確認結果未承認
  KANKETSU_TORIKESHI: '53', // 完結(取消)
  TOROKU_ZUMI_ITEN_MI: '54', // 登録済（移転処理未）
  JYUNSI_KAISYU_TUTI_CREATE: '61', // 作成中（巡視発見改修）
  KAISYU_TUTI_HAKKO_SHINSEITYU: '62', // 改修通知発行申請中
  KAISYU_TUTI_SUMI: '63', // 改修通知済
  KAISYU_HOUHOU_KENTOTYU: '64', // 改修方法検討中
  KYOGIKEKKA_TOROKUZUMI: '65', // 協議結果登録済(当社起因)
  KYOGASYA_KAISYU_KOJI_TYU: '66', // 共架者改修工事中
  KAISYU_SEKKEI_IRAI_CHU: '67', // 改修設計依頼申請中
  KAISYU_KOJI_MOUSIKOMI_MI: '68', // 改修工事申込未
  KAISYU_KOJI_MOUSIKOMI_SINSEI_CHU: '69', // 改修工事申込申請中
  KAISYU_KAHI_HANTEI_IRAIMI: '72', // 改修可否判定依頼未
  KAISYU_KAHI_HANTEI_IRAITYU: '73', // 改修可否判定依頼中
  TOUSYA_KAISYU_SASIMODOSI: '74', // 当社改修否差戻
};

// 申込ステータス（他社柱）
export const ORDER_STATUS_NTT = {
  ORDER_CREATED: '01', // 作成中
  KYOGA_ORDER_SHINSEITYU: '02', // 共架申込申請中
  GIJYUTU_KENTO_ORDER_RECEIVE: '03', // 技術検討申込承認済/申込済
  ORDER_CANCELING: '04', // 取消申請中
  ORDER_CREUKETUKEDUMIATED: '05', // 受付済
  GIJYUTU_KENTOZUMI_KAISYU_SEKKEITYU: '10', // 技術検討済/改修設計中
  KOJI_PLAN_ZUMI: '11', // 工事計画済
  KYOGA_KOJI_KAISHI_KA: '12', // 共架工事開始可
  KYOGA_KOJI_PLAN_ZUMI: '13', // 共架工事計画済
  SYUNKO_TOROKU_SUMI: '14', // しゅん工登録済
  KANKETSU: '21', // 完結
  KANKETSU_TORIKESHI: '22', // 完結（取消）
  ORDER_CANCEL_CREATED: '23', // 取消依頼作成中
};


// 共架柱登録ステータス
export const KYOGATYU_TOROKU_STATUS = {
  CREATE: '0', // 作成中
  TOROKU_SHINSEITYU: '1', // 共架柱登録申請中
  MIKAKUNIN: '2', // 共架者未確認
  KAKUNIN_SHINSEITYU: '3', // 共架者確認申請中
  KANKETSU: '4', // 完結
};


// 電柱所有者
export const OWNER = {
  CHUDEN_HAIDEN: '1', // 中電（配電）
  CHUDEN_TUSHIN: '2', // 中電（通信）
  NTT: '3', // NTT
  KANKOTYO: '4', // 官公庁
  SONOTA: '9', // その他
};

// 有無区分
export const UMU_CATEGORY = {
  ARI: '1',
  NASHI: '0',
};

// 異動種別
export const IDO_TYPE = {
  SHINSETU: '1',
  HAISHI: '2',
  HENKO: '3',
  HENKO_SHINSETU: '5',
  HENKO_TEKKYO: '6',
  HENKO_ZOJYO: '7',
  HENKO_GENJYO: '8',
  HENKO_SONOTA: '9',
};

// 異動種別（共架柱登録）
export const IDO_TYPE_KYOGATYU = {
  SHINSETU: '1',
  HAISHI: '2',
  HENKO: '3',
  DNT_HENKO: '4',
};

// 電柱ID種別
export const DNT_ID_TYPE = {
  BUKKEN_SETUBI: '1',
  BUKKEN_BUNKI: '2',
  SETUBI: '3',
  BUNKI: '4',
  MITOUROKU: '5',
  OTHER: '9',
};

export const BUNKITEN_MITOROKU_TYPE = {
  BUNKI: '0',
  MITOUROKU: '1',
};

// 取付手段
export const TORITUKE_WAY = {
  JIKADUKE: 'D', // 直付
  DENTU_TURISEN: 'T', // 電通吊線
  UDEGANE_SUIHEI: 'H', // 腕金（水平）
};

// 取付種別
export const TORITUKE_TYPE = {
  HIKITOME: 'C', // 引留
  TORI: 'O', // 通り
  UDEGANE_CHUSIN: 'N', // 腕金（中心側）
  UDEGANE_SOTO: 'F', // 腕金（外側）
};

// 架設設備コード
export const KASETU_SETUBI_CD = {
  OTHER_SETUBI: '699', // その他：その他設備
  SENKO_KENTYU_KJ: '117', // 先行建柱（強弱）
  SENKO_KENTYU_JJ: '116', // 先行建柱（弱弱）
};

// 架設設備コード（NTT）
export const KASETU_SETUBI_CD_NTT = {
  SENKO_KENTYU_KJ: '023', // 先行建柱（強弱）
  SENKO_KENTYU_JJ: '012', // 先行建柱（弱弱）
};

// 最接近配電設備
export const SAISEKKIN_HAIDEN_SETUBI = {
  KOATU_ZETUEN: '1', // 高圧線：絶縁電線
  KOATU_CABLE: '2', // 高圧線：ケーブル
  TEIATU_ZETUEN: '3', // 低圧線：絶縁電線
  TEIATU_CABLE_KOATU: '4', // 低圧線：ケ－ブル・高圧絶縁電線
  TEIATU_CABLE_KOATU2: '5', // 低圧線：ケ－ブル・高圧絶縁電線
  TEIATUHIKIKOMI_ZETUEN: '6', // 低圧引込線：絶縁電線
  TEIATUHIKIKOMI_CABLE_KOATU: '7', // 低圧引込線：ケ－ブル・高圧絶縁電線
  TEIATUHIKIKOMI_TOKUBETU: '8', // 低圧引込線：特別高圧絶縁電線
  HENATU: '9', // 変圧器底部
  NTT_KOATU_ZETUEN: '12', // 高圧線：絶縁電線
  NTT_TEIATU_KOATU: '13', // 高圧線：高圧絶縁電線
  NTT_KOATU_CABLE: '14', // 高圧線：ケーブル
  NTT_TEIATU_ZETUEN: '16', // 低圧線：絶縁電線
  NTT_TEIATU_CABLE_KOATU: '17', // 低圧線：高圧絶縁電線
  NTT_HENATU: '18', // 変圧器一次リード線
  NTT_HIKIKOMI: '19', // 引込線
  OTHER: '98', // その他設備
  NASHI: '99', // 該当なし
};

// 線下状況
export const SENKA_JYOKYO = {
  DOROODAN: '1', // 道路横断
  DOROJYO: '2', // 道路上
  HODOJYO: '3', // 歩道上
  ROMENJYO: '4', // 横断歩道橋の路面上
  TETUDO: '5', // 鉄道・軌道横断
  KASEN: '6', // 河川横断・水面上
  OTHER: '7', // その他
};

// 会社区分
export const COMPANY_CATEGORY = {
  IPPAN: '0',
  KYOTEI: '1',
  NTT: '2',
  TUSHIN: '3',
  KYU_IPPAN: '4',
};
// 減額区分
export const GENGAKU_CATEGORY = {
  YUSHOU: '0',
  MUSHOU: '2',
};
// 会社種別
export const COMPANY_TYPE = {
  NTT: 'NTT',
  OTHER: 'NTT以外',
  ALL: '両方',
};
// 選択肢架設設備種別
export const KASETU_SETUBI_TYPE_SELECTION = {
  TUSHIN: '通信',
  ALL: '両方',
};

// 会社マスタの会社種別。汎用マスタではcampany_type

export const COMPANY_TYPE_COMPANY_MST = {
  IPPAN: '0', // 一般
  TYUDENPG: '1', // 中電
};
export const KYOGATYU_HENKO_STATUS = {
  HENKO_CREATED: '01', // 作成中
  HENSHUZUMI_ZIZEN: '02', // 編集済（事前）
  HENSHUZUMI_HON: '03', // 編集済（本）
  HENKORENRAKUTYU_ZIZEN: '11', // 変更連絡中（事前）
  HENKORENRAKUZUMI_ZIZEN: '21', // 変更連絡済（事前）
  HENKORENRAKUTYU_HON: '12', // 変更連絡中（本）
  HENKORENRAKUTYU_TORIKESHI: '14', // 変更連絡中（取消）
  HENKORENRAKUZUMI_HON: '22', // 変更連絡済（本）
  HENSHUTYU_HON: '32', // 編集中（本）
  HENSHUTYU_TORIKESHI: '33', // 編集中（取消）
  YOTEI_TOUROKU: '41', // 予定登録中
  YOTEI_TOUROKUZUMI: '42', // 予定登録済
  ISETUTYU: '43', // 移設中
  KYOGAKOUJI_ZUMI_KARIYU: '44', // 共架者工事完了済(仮有）
  KYOGAKOUJI_ZUMI: '45', // 共架者工事完了済
  KANKETU_ISETU: '51', // 完結（移設済）
  KANKETU_TORIKESHI: '52', // 完結(取消)
};

export const KYOGATYU_HENKO_KYOGASYA_STATUS = {
  MITUTI: '01', // 未通知
  MIJYURI_JIZEN: '02', // 未受理（事前）
  MIJYURI_HON: '03', // 未受理（本）
  MITUTI_TORIKESHI: '04', // 未通知（取消）
  JYURIZUMI_JIZEN: '11', // 受理済（事前）
  JYURIZUMI_HON: '12', // 受理済（本）
  YOTEI_TOUROKUZUMI: '21', // 予定登録済
  KARI_ZUMI: '22', // 仮移設済
  KANKETU_ISETU: '31', // 完結（移設済）
  KANKETU_TORIKESHI: '32', // 完結（取消）

};

export const MOSIKOMISYA_YUSYOMUSYO_CATEGORY ={
  YUSHOU: '0', // 有償
  MUSHOU: '1', // 無償
};

export const HENKOU_RENRAKU_CATEGORY ={
  JIZEN: '0', // 事前
  HON: '1', // 本
  TORIKESHI: '3', // 取消
};

export const KAHI_CATEGORY ={
  KA: '0', // 可
  HI: '1', // 否
};

// 要否区分
export const YOUHI_CATEGORY = {
  YOU: '1',
  HI: '0',
};

// 技術検討結果
export const GIJYUTU_KENTO_KEKKA_CATEGORY = {
  KYOGA_KANOU: '1', // 共架可（条件無し）
  KYOGA_KANOU_JOKEN_ARI_SYUSEI_YOU: '2', // 共架可（条件有り,申込修正要）
  KYOGA_KANOU_JOKEN_ARI_SYUSEI_NASI: '3', // 共架可（条件有り、申込修正不要）
  KYOGA_HUKA: '4', // 共架不可
  GENBA_TYOSA_YOU: '5', // 現場調査要
};

export const GIJYUTU_KENTO_KEKKA_CATEGORY_FILTER = {
  COMMON: '両方',
};

// 技術検討結果 可条件
export const GIJYUTU_KENTO_KEKKA_KAJOKEN_CATEGORY = {
  ISSOKUKA_YOUTYOUSEI: '01', // 一束化相手と調整要
  TASYASETUBI_KAISYUIRAIYOU: '02', // 他社設備改修依頼要
  KYODOSISEN_ENTYOYOU: '03', // 共同支線の施設（延長）要
  SONOTA_SYUSEIYOU: '09', // その他（申込修正要）
  TYUDEN_KAIAYUKOJIYOU: '11', // 中電改修工事要
  HIIPARIKAJYU_SIJIARI: '12', // 引張荷重指示有り
  ISSOKUKA_GOUIZUMI: '13', // 一束化（合意済）
  TASYASETUBI_KAISYU_GOUIZUMI: '14', // 他社設備改修（合意済）
  SONOTA_SYUSEIHUYOU: '19', // その他（申込修正不要)
};

// 技術検討 共架不可理由
export const GIJYUTU_KENTO_KEKKA_FUKARIYU = {
  GUIDE_LINE1: '1', // 総務省ガイドライン第3条第1号に該当
  GUIDE_LINE2: '2', // 総務省ガイドライン第3条第2号に該当
  GUIDE_LINE3: '3', // 総務省ガイドライン第3条第3号に該当
  GUIDE_LINE4: '4', // 総務省ガイドライン第3条第4号に該当
  GUIDE_LINE5: '5', // 総務省ガイドライン第3条第5号に該当
  GUIDE_LINE6: '6', // 総務省ガイドライン第3条第6号に該当
  GUIDE_LINE7: '7', // 総務省ガイドライン第3条第7号に該当
  GUIDE_LINE8: '8', // 総務省ガイドライン第3条第8号に該当
  GUIDE_LINE9: '9', // 総務省ガイドライン第3条第9号に該当
  SONOTA: '99', // その他
};

// 技術検討 現場調査回付理由
export const GIJYUTU_KENTO_KEKKA_GENBARIYU = {
  SIJIBUTU_MUKI: '1', // 支持物の向きが不明
  SIJIBUTU_SYAKU_KYODO: '2', // 支持物の丈尺・強度が不明
  KEIKAN_KAKUNIN: '3', // 径間・角度・弛度・地上高要確認
  SONOTA: '9', // その他
};

// 紐移設実施区分
export const HIMO_IAETU_JISSI_CATEGORY = {
  KYOGASYA: '1', // 共架者
  HAIDEN: '2', // 配電
  TUSIN: '3', // 通信
};

// 要否区分（配電改修設計）
export const YOUHI_CATEGORY_HAIDEN_KAISYU = {
  YOU_HIMOISETU_NOMI: '1',
  YOU_HIMOISETU_NOZOKU: '2',
  HI: '0',
};

// 伝票区分
export const DEMPYO_CATEGORY = {
  KANREN: '0',
  HAIDEN_SINKI: '1',
  TUSIN_SINKI: '2',
  KISETU: '3',
};

// 承認ステータス
export const APPROVAL_STATUS = {
  SHINSEI_MI: '00', // 未申請・承認済
  SHINSEI_TYU: '01', // 申請中
  SHINSEI_SAI: '03',  // 要再申請
};

// 共架柱変更_対象柱工事内容
export const KYOGATYU_HENKO_KOJI_NAIYO = {
  TATEKAE: '1', // 建替
  MOTO: '2', // 元位置建替
  SINSETU: '3', // 新設
  TEKKYO: '4', // 撤去
  OTHER: '9', // その他
};

// 共架柱変更移設工事内容
export const KYOGATYU_HENKO_ISETU_KOJI_NAIYO = {
  TUKEKAE: '01', // 電柱建替に伴い共架設備付け替え
  SETUBI_DOWN: '02', // 共架設備繰り下げ
  SETUBI_UP: '03', // 共架設備繰り上げ
  OTHER: '09', // その他
  MOSIKOMI_TEKYO: '11', // 不要線のため撤去（共架申込要）
  MOSIKOMI_NASI: '12', // 現地設備無し（共架申込要）
  MOSIKOMI_TORIHAZU: '13', // 電柱間引に伴い取り外し（共架申込要）
  MOSIKOMI_TORITUKE: '14', // 電柱割込新設に伴い取り付け（共架申込要）
  MOSIKOMI_OTHE: '19', // その他（共架申込要）
};

// 共架費用区分
export const KYOGA_HIYO_CATEGORY = {
  KYOGA_HOKA: '000', // 共架料ほか
  KYOGA: '010', // 共架料
  TEKI_KYOGA: '011', // 定期共架料
  TUKIWARI_KYOGA_SINSETU: '012', // 月割共架料（新設）
  TUKIWARI_KYOGA_TEKKYO: '013', // 月割共架料（撤去）
  TUKIWARI_KYOGA: '015', // 月割共架料
  KYOGA_SEIKYU: '016', // 共架料（請求）
  KYOGA_SIHARAI: '017', // 共架料（支払）
  SEISAN_KYOGA: '020', // 精算共架料
  GIJYUTU_KENTO_HIYO: '030', // 技術検討費用
  KAISYU_KOJI_HIYO_YOTE: '040', // 改修工事費用（予定）
  KAISYU_KOJI_HIYO_KANKO: '041', // 改修工事費用（完工）
  KARIISETU_HIYO: '050', // 仮移設費用
  SYUNKO_DAIKO_HIYO: '060', // しゅん工報告代行費用
  KYOGA_ORDER_DAIKO_HIYO: '061', // 共架申込代行費用
  SYUNKO_ORDER_DAIKO_HIYO: '062', // しゅん工報告代行費用
  SYUNKO_TYOSA_HIYO: '070', // しゅん工調査費用
  ENTAI: '080', // 延滞利息
  KOBETU_SEIKYU_HIYO_SINSEI: '090', // 個別費用請求・払戻
};
export const HENKO_RENRAKU_TAISYO = {
  TAISYO: '1', // 対象
  TAISYOGAI: '2', // 対象外
};

export const HENKO_RENRAKU_TUTI_HOHO = {
  SYSTEM: '1',      // システム
  KOBETU_TAIO: '2', // 個別（事業場対応）
  KOBETU_HASO: '3', // 個別（集中部署発送）
};

// 施設確認結果
export const TEKI_FUTEKI_CATEGORY ={
  TEKI: '0', // 適
  HUTEKI: '1', // 不適
};

// 不適区分
export const FUTEKI_CATEGORY={
  RIKAKU_FUSOKU: '1', // 離隔不足
  TIJYO_HEIGHT_FUSOKU: '2', // 地上高不足
  KISAI_MORE: '3', // 記載漏れ
  TENPU_MORE: '4', // 添付漏れ
  PIC_SOI: '5', // 写真相違
  PIC_FUSENMEI: '6', // 写真不鮮明
  DNTNO_SOI: '7', // 電柱番号相違
  OTHER: '9', // その他
};

// 改修設計（配電）ステータス
export const KAISYU_SEKKEI_HAIDEN_STATUS = {
  KAISYU_SEKKEI_MI: '1',        // 改修設計未
  KAISYU_SEKKEI_ZUMI: '2',      // 改修設計済
};

// 改修設計（通信）ステータス
export const KAISYU_SEKKEI_TUSIN_STATUS = {
  KAISYU_SEKKEI_MI: '1',        // 改修設計未
  KAISYU_SEKKEI_SYONIN_MI: '2', // 改修設計承認未
  KAISYU_SEKKEI_ZUMI: '3',      // 改修設計済
};

export const COMPANY_CD = {
  CHUDEN_PG: '1', // 中電PG
  CHS: '2', // CHS
};

export const ZIGYOJO_CATEGORY = {
  TOUKATSU: '00', // 統括
  HAIDEN: '01', // 配電
  TUSIN: '02', // 通信
  HAIDEN_TOUKATSU: '10', // 配電統括
  HAIDEN_ITAKU: '11', // 配電委託
  TUSIN_HOSYU: '21', // 通信保守
};

export const ZIGYOJO_LEVEL = {
  HONSYA: '00', // 本社
  SISAYA: '10', // 支社
  SISYA_ZIGYOJO: '11', // 支社事業場
  EREA_SISYA: '20', // エリア支社
  TUSIN_CENTER: '25', // 通信センター
  ICHIGATA_SS: '30', // 営業所・1型SS
  NIGATA_SS: '40', // 2型SS
};

// 役割ロールID（アクター種類）
export const ROLE_ID = {
  KYOGASYA: '00',
  HAIDENBU: '01',
  KYOGA: '02',
  SEKKEI: '03',
  KOJI: '04',
  KENSA: '05',
  YOUTI: '06',
  SETUBI_HOSYU: '07',
  UKETUKE_TEAM: '08',
  GIJYUTU_TEAM_CENTER: '09',
  GIJYUTU_TEAM_KYOTEN: '10',
  GIJYUTU_TEAM_GENBA: '11',
  TUSIN_CENTER: '12',
  TUSIN_HOSYUKAISYA: '13',
  SYSTEM_UNYOHOSYU: '14',
};

// 改修通知方法（巡視）
export const KAISYO_TUTIHOHO_JYUNSI = {
  SYSTEM: '1',
  INDIVIDUAL: '2',
};

// 共架区分
export const KYOGA_CATEGORY ={
  KYO_JAKU: '1', // 強弱
  JAKU_JAKU: '2', // 弱弱
};

// CSVフォーマット(会社)
export const CSV_COMPANY_FORMAT = {
  '名称': {
    binding: 'name',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '名称カナ': {
    binding: 'nameKana',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '代表者部署名': {
    binding: 'daihyoBusyoName',
    type: 'string',
    maxlength: 30,
    required: true,
  },
  '代表者名': {
    binding: 'daihyoName',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '代表者名カナ': {
    binding: 'daihyoNameKana',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '郵便番号': {
    binding: 'zipCd',
    type: 'string',
    maxlength: 7,
    required: true,
  },
  '住所（都道府県）': {
    binding: 'addressPrefectures',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（市区町村）': {
    binding: 'addressMunicipalities',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（大字通称）': {
    binding: 'addressOazatusyo',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（字丁目）': {
    binding: 'addressAzatyome',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（ビル名等）': {
    binding: 'addressBirumei',
    type: 'string',
    maxlength: 255,
  },
  '電話番号': {
    binding: 'tel',
    type: 'string',
    maxlength: 11,
    required: true,
  },
  'メールアドレス': {
    binding: 'email',
    type: 'string',
    maxlength: 11,
    required: true,
  },
  '記事欄': {
    binding: 'kiji',
    type: 'string',
    maxlength: 255,
  },
};

// CSVフォーマット(事業者)
export const CSV_ZIGYOSYA_FORMAT = {
  '名称': {
    binding: 'name',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '名称カナ': {
    binding: 'nameKana',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '代表者部署名': {
    binding: 'daihyoBusyoName',
    type: 'string',
    maxlength: 30,
    required: true,
  },
  '代表者名': {
    binding: 'daihyoName',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '代表者名カナ': {
    binding: 'daihyoNameKana',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '郵便番号': {
    binding: 'zipCd',
    type: 'string',
    maxlength: 7,
    required: true,
  },
  '住所（都道府県）': {
    binding: 'addressPrefectures',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（市区町村）': {
    binding: 'addressMunicipalities',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（大字通称）': {
    binding: 'addressOazatusyo',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（字丁目）': {
    binding: 'addressAzatyome',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '住所（ビル名等）': {
    binding: 'addressBirumei',
    type: 'string',
    maxlength: 255,
  },
  '電話番号': {
    binding: 'tel',
    type: 'string',
    maxlength: 11,
    required: true,
  },
  'メールアドレス': {
    binding: 'email',
    type: 'string',
    maxlength: 11,
    required: true,
  },
  '共架種別': {
    binding: 'kyogaType',
    type: 'string',
    required: true,
  },
};

// CSVフォーマット(ユーザ)
export const CSV_USER_FORMAT = {
  '名前（姓）': {
    binding: 'lastName',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '名前（姓）カナ': {
    binding: 'lastNameKana',
    type: 'string',
    maxlength: 30,
    required: true,
  },
  '名前（名）': {
    binding: 'firstName',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '名前（名）カナ': {
    binding: 'firstNameKana',
    type: 'string',
    maxlength: 20,
    required: true,
  },
  '電話番号': {
    binding: 'tel',
    type: 'string',
    maxlength: 11,
    required: true,
  },
  'メールアドレス': {
    binding: 'email',
    type: 'string',
    maxlength: 11,
    required: true,
  },
};

// CSVフォーマット(契約利用申込)
export const CSV_KEIYAKU_RIYO_FORMAT = {
  '申込種別': {
    binding: 'orderType',
    type: 'string',
    maxlength: 4,
    required: true,
  },
  '申込日': {
    binding: 'orderDate',
    type: 'date',
    maxlength: 10,
    required: true,
  },
  '共架物件種類コード': {
    binding: 'kyogaBukkenKindCd',
    type: 'string',
    maxlength: 4,
    required: true,
  },
  '共架場所_代表電柱番号': {
    binding: 'kyogabasyoDaihyoDntNo',
    type: 'string',
    maxlength: 50,
    required: true,
  },
  '共架場所_都道府県': {
    binding: 'kyogabasyoPrefectures',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '共架場所_市区町村': {
    binding: 'kyogabasyoMunicipalities',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '共架場所_事業場': {
    binding: 'kyogabasyoZigyojo',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '共架場所_場所': {
    binding: 'kyogabasyoPlace',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '電柱番号一覧': {
    binding: 'dntNoList',
    type: 'string',
    maxlength: 1024,
    required: true,
  },
  '共架目的': {
    binding: 'kyogaMokuteki',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '共架希望日': {
    binding: 'kyogaKiboDate',
    type: 'date',
    maxlength: 10,
    required: true,
  },
  '共架物件数': {
    binding: 'kyogaBukkensu',
    type: 'number',
    required: true,
  },
  '記事欄': {
    binding: 'kiji',
    type: 'string',
    maxlength: 255,
  },
};

// CSVフォーマット(共架物件種類)
export const CSV_KYOGA_BUKKEN_SYURUI_FORMAT = {
  '共架物件種類コード': {
    binding: 'kyogaBukkenSyuruiCd',
    type: 'string',
    maxlength: 4,
    required: true,
  },
  '申込日': {
    binding: 'orderDate',
    type: 'date',
    maxlength: 10,
    required: true,
  },
  '申込ユーザー': {
    binding: 'orderUser',
    type: 'string',
    maxlength: 255,
    required: true,
  },
  '共架目的': {
    binding: 'kyogaMokuteki',
    type: 'string',
    maxlength: 255,
    required: true,
  },
};

// 重要度
export const JYUYODO = {
  TUTI: '0', // 通知
  YOUKAKUNIN: '1', // 要確認
  YOUKAITOU: '2', // 要回答
};

// 連絡種別
export const JYUYOJIKO_RENRAKU_TYPE = {
  YAKKAN: '0', // 約款
  RENRAKUJIKO: '1', // 連絡事項
  KEIYAKUKAIJOTUTI: '2', // 契約解除
};

// 通知先種別
export const JYUYOJIKO_TUTISAKI_CATEGORY = {
  Kyogasya: '01', // 共架者
  CHS: '02', // CHS
  CEPG: '03', // 中電PG
  KyogasyaCHS: '04', // 共架者＋CHS
  KyogasyaPG: '05', // 共架者＋中電PG
  CHSPG: '06', // CHS＋中電PG
  KyogasyaCHSPG: '07', // 共架者＋CHS＋中電PG
};

// メッセージステータス
export const MESSAGE_STATUS = {
  CREATED: '1', // 作成中
  SOUSIN_ZUMI: '2', // 送信済
  TAIOUTYU: '3', // 対応中
  KAITOU_ZUMI: '4', // 回答済
  KAKUNIN_ZUMI: '5', // 確認済
};

// ユーザーレベル
export const USER_LEVEL = {
  ADMIN: '0', // 管理者
  GENERAL: '1', // 一般
};

// 改修工事（配電）ステータス
export const KAISYU_KOJI_HAIDEN_STATUS = {
  KOJI_IRAIZUMI: '0',        // 工事依頼済
  KOJI_KEIKAKUMI: '1', // 工事計画未
  KOJI_KEIKAKUZUMI: '2',      // 工事計画済
  KOJIKANRYOU: '3', // 工事完了
};

// 改修工事（通信）ステータス
export const KAISYU_KOJI_TUSIN_STATUS = {
  KOJI_IRAIZUMI: '0',        // 工事依頼済
  KOJI_KEIKAKUMI: '1', // 工事計画未
  KOJI_KEIKAKUZUMI: '2',      // 工事計画済
  KOJIKANRYOU: '3', // 工事完了
};

// 共架基本契約ステータス
export const KEIYAKU_STATUS = {
  MOUSIKOMITYU: '1',        // 申込中
  KARI_MOUSIKOMI: '2', // 仮申込
  KEIYAKUSYO_KAKUNINZUMI: '3',      // 契約書案確認済
  HONTEIKETU_MATI: '4', // 契約本締結待ち
  SOUHUZUMI: '5', // 契約送付済
  KANKETU_TEIKETUZUMI: '6', // 完結（締結済）
  KANKETU_HI: '7', // 完結（否）
};
// 同調施工可否
export const DOTYOSEKO_KAHI = {
  KA: '0',     // 可
  HI: '1',      // 否
  FUMEI: '9',   // 不明
};
// 架設設備種別 架設設備コードの値_数値1
export const KASETU_SETUBI_TYPE = {
  TUSHIN: 1,
  KIKI: 2,
  GAIROTO: 3,
};
// 当社改修依頼否理由
export const TOSYA_KAISYU_IRAI_HI_RIYU ={
  HAIDEN_SETUBI_KAISYU_HOHO_NASI: '1',
  HOKA_KYOGASYA_KAISYU: '2',
  OTHER: '9',

};

/** 官民区分 */
export const KAN_MIN_CATEGORY = {
  KANTI: '1',
  MINTI: '2',
};

export const ENTRY_SYSTEM = {
  MAINTE: '1',
  BATCH: '2',
};

// 地図更新区分
export const UPDATE_CATEGORY ={
  INSERT: 1, // 新設
  UPDATE: 2, // 更新
  DELETE: 3, // 削除

};

export const RENKEI_CATEGORY = {
  BS: '0',
  SONOTA: '1',
};

// 権限ID
export const KENGEN_ID = {
  GAIROTO: 'C14',
};

/** デフォルト検索結果上限(汎用マスタから取得できなかった場合用) */
export const DEFAULT_SEARCH_LIMIT = 2000;

// 共架柱変更連絡共架者毎ステータス（他社柱）
export const KYOGATYU_HENKO_KYOGASYA_STATUS_TASYA = {
  MITUTI: '00', // 未通知
  MIJYURI_JIZEN: '01', // 未受理（事前）
  MIJYURI_HON: '04', // 未受理（本）
  JYURIZUMI_JIZEN: '02', // 受理済（事前）
  JYURIZUMI_HON: '03', // 受理済（本）
  YOTEI_TOUROKUZUMI: '11', // 予定登録済
  KYOGAKOUJI_ZUMI: '12', // 共架柱工事済
  KANKETU_ISETU: '21', // 完結
  KANKETU_TORIKESHI: '22', // 完結（取消）
};


// 共架者廃止ステータス
export const KYOGASYA_HAISI_STATUS = {
  MISYUSAIKEN_NASI: '30', // 未収債権無し
  HAISIKAIYAKU_SINSEI_CHU: '80', // 廃止解約申請中
};

// 連絡票発行区分
export const RENRAKUHYO_HAKKO_CATEGORY = {
  NTT: '1',
};

// 非一束化対応前の異動種別（新設、廃止、変更）
export const IDO_TYPE_CURRENT = '1';

// 異動種別を分類するための架設設備種別
export const KASETU_SETUBI_TYPE_FOR_IDO_TYPE = {
  ALL: '0', // 通信設備、機器設備両方
  TUSHIN: '1',
  KIKI: '2',
};

// 仮移設費用算出ステータス
export const KARIISETU_HIYO_SANSYUTU_STATUS = {
  MISANSYUTU: '0', // 未算出
  SHINSEITYU: '1', // 算出申請中
  SHINSEIZU: '2',  // 算出済
  TAISYOGAI: '9',  // 算出対象外
};
// 決済方法
export const KESSAI_HOHO = {
  PRE: '0', // 前払い
  AFTER: '1', // 後払い
  TUDO: '2', // 都度
};
/** 単価区分. */
export const UNIT_PRICE_CATEGORY = {
  KYOGA: 'KG',
  GIJYUTU_KENTO: 'GK',
  HAIDEN_BASE: 'HB',
  HAIDEN_KASAN: 'HK',
  TUSIN_BASE: 'TB',
  KARIISETU: 'KI',
  ORDER_DAIKO: 'MD',
  SYUNKO_DAIKO: 'SD',
  SYUNKO_TYOSA: 'ST',
};

// 請求書作成区分
export const SEIKYUSYO_CREATE_CATEGORY = {
  IKATU_HASO: '1', // 一括印書＋一括発送
  PC_PRINT: '2', // ＰＣプリンタ印書
  BUSYO_HASO: '3', // 一括印書＋自部署発送
  SYSTEM_KOBETU: '5', // 債権システム個別作成
  CREATE_FUYO: '9', // 請求書作成不要
};

// 支払方法区分
export const SIHARAI_HOHO_CATEGORY = {
  FURI_HYO_KOMI: '1', //  振込票
  FURI_SENYO_KOZA: '2', // 振込専用口座
  FURI_HYO_SENYO_KOZA: '3', // 振込票・振込専用口座
  KOZA_FURIKAE: '4', // 口座振替
  SIHARAI_FUYO: '9', // 支払不要
};

// 設備確認
export const SETUBI_KAKUNIN = {
  MIKAKUNIN: '0', //  未確認
  KAKUNINZUMI: '1', // 確認済
};
